import { useQuery } from "@tanstack/react-query";

import { prepareAudioRecordingDownloadUrl } from "@/modules/audio-recording/prepare-download";

export const useAudioRecordingDownloadUrl = ({
  audioRecordingId,
  isEnabled,
}: {
  audioRecordingId: string | null;
  isEnabled: boolean;
}): {
  downloadUrl: string | null;
  isPreparing: boolean;
  error: unknown;
  refetch: () => void;
} => {
  const query = useQuery({
    queryKey: ["audio-recording-download-url", audioRecordingId],
    queryFn: async () => {
      if (!audioRecordingId) throw new Error("Missing audio recording id");
      return prepareAudioRecordingDownloadUrl({ audioRecordingId });
    },
    enabled: isEnabled && Boolean(audioRecordingId),
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });

  return {
    downloadUrl: query.data ?? null,
    isPreparing: query.isLoading || query.isFetching,
    error: query.error,
    refetch: () => {
      void query.refetch();
    },
  };
};
